module.exports = __webpack_public_path__ + "static/media/logo-grupo-aspecir-negativo.016f2252.png";